import QuizQuestionComponent from '@efdigital/ll-addon-content/components/quiz/quiz-question';
import answerFor from '@efdigital/ll-addon-content/helpers/answer-for';
import type { Quiz, QuizQuestion } from '@efdigital/ll-addon-data';
import type { Answer } from '@efdigital/ll-addon-data';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type { EditingContext } from '../edit-context.gts';
import { lookupQuestionManager } from './edit-quiz-questions/utils.ts';

export class IsolatedQuizQuestion extends Component<{
  Args: {
    quiz: Quiz;
    answers: Answer;
    context: EditingContext;
    isolatedIndex: number;
    isolate: (index: number) => void;
  };
}> {
  get isolatedQuestion(): QuizQuestion {
    return this.args.quiz.questions[this.args.isolatedIndex]!;
  }

  <template>
    {{#let (lookupQuestionManager this.isolatedQuestion) as |questionManager|}}
      {{! template-lint-disable no-inline-styles }}
      <div class="container py-3 sticky-top">
        <div class="card rounded-4 shadow">
          <div
            class="card-header p-2 d-flex justify-content-between align-items-center text-bg-white rounded-top-4"
          >
            <h4 class="card-title h5 my-0 text-muted"><iconify-icon
                inline
                icon={{questionManager.icon}}
                class="mx-2"
              />
              {{questionManager.label}}</h4>
            <button
              type="button"
              class="btn btn-sm btn-primary fw-bold"
              {{on "click" (fn @isolate -1)}}
            >
              <iconify-icon inline icon="ph:x-bold" />
              Close Preview
            </button>
          </div>
          <div class="card-body px-5 pt-5">
            <QuizQuestionComponent
              @readonly={{false}}
              @question={{this.isolatedQuestion}}
              @quiz={{@quiz}}
              @answer={{answerFor @answers this.isolatedQuestion}}
            />
          </div>
        </div>
      </div>
    {{/let}}
  </template>
}
